export const apiMerchant = 'https://website-service-dot-autoketing-production-api-v1.appspot.com';
export const apiSubmitTicket = 'https://website-service-dot-autoketing-production-api-v1.appspot.com/create-ticket';


// url dashboard apps suggestion
export const fbChatBoxDashboardUrl = 'https://shop.dashboard/';
export const salesPopDashboardUrl =
  'https://sale-popup-dot-autoketing-prod-dashboard.appspot.com/';
export const currencyConvertDashboardUrl =
  'https://currency-convert-dot-autoketing-prod-dashboard.appspot.com/';
export const emailWithLoveDashboardUrl =
  'https://email-with-love-dot-autoketing-prod-dashboard.appspot.com/';


export const appInfoParameter = 'https://app.info/';
export const logoFacebookChatBox =
  'https://autoketing-prod-dashboard.appspot.com/icons/autoketing-logo-shopify.png';
